/** @format */
/* eslint-disable react-hooks/exhaustive-deps */

import { useEffect } from 'react'
import { useTimer } from 'use-timer'
import _ from 'lodash'

/**
 * Check if touch device
 */
export function is_touch_device() {
  return (
    'ontouchstart' in window ||
    navigator.MaxTouchPoints > 0 ||
    navigator.msMaxTouchPoints > 0
  )
}

const _vibrate = function() {
  try {
    window.navigator.vibrate.apply(window.navigator, arguments)
  } catch (err) {}
}

const __vibrate = _.throttle(_vibrate, 500)

export function vibrate() {
  if (is_touch_device()) {
    __vibrate()
  }
}

window.gameHeight = Math.min(
  document.documentElement.clientHeight,
  window.innerHeight || 0,
)
window.gameWidth = Math.min(
  document.documentElement.clientWidth,
  window.clientWidth || 0,
)
var timeout = false

/**
 * window.resize callback function
 */
function getDimensions() {
  // var game = document.getElementsByClassName('game')[0]
  window.gameHeight = Math.max(
    document.documentElement.clientHeight,
    window.innerHeight || 0,
  )
  window.gameWidth = Math.max(
    document.documentElement.clientWidth,
    window.innerWidth || 0,
  )
  // console.log('game :: resize to', window.gameWidth, window.gameHeight, game)

  return {
    width: window.gameWidth,
    height: window.gameHeight,
  }
}

export function initSizeListener() {
  /**
   * window.resize event listener
   */
  window.addEventListener('resize', function(event) {
    /* console.log('window :: resize event', event); */
    timeout && clearTimeout(timeout) /* clear the timeout */
    timeout = setTimeout(
      getDimensions,
      500,
    ) /* start timing for event "completion" */
  })

  timeout && clearTimeout(timeout) /* clear the timeout */
  timeout = setTimeout(
    getDimensions,
    100,
  ) /* start timing for event "completion" */
}

export function refreshWindowSize() {
  timeout && clearTimeout(timeout) /* clear the timeout */
  timeout = setTimeout(
    getDimensions,
    500,
  ) /* start timing for event "completion" */

  return getDimensions()
}

// Position variables
var x1 = 0,
  y1 = 0,
  z1 = 0,
  x2 = 0,
  y2 = 0,
  z2 = 0
var z, x, y

if (typeof window.DeviceMotionEvent !== 'undefined') {
  // Shake sensitivity (a lower number is more)
  var sensitivity = 100

  // Listen to motion events and update the position
  window.addEventListener(
    'devicemotion',
    function(e) {
      x1 = e.accelerationIncludingGravity.x
      y1 = e.accelerationIncludingGravity.y
      z1 = e.accelerationIncludingGravity.z
    },
    false,
  )
}

export function useDetectShake(cb) {
  const { time, start, reset } = useTimer({
    interval: 100,
  })

  // Periodically check the position and fire
  // if the change is greater than the sensitivity
  useEffect(
    function() {
      // console.log('useDetectShake :: time', time);

      var change = Math.abs(x1 - x2 + y1 - y2 + z1 - z2)

      if (change > sensitivity) {
        // console.log('useDetectShake :: Shake!')

        cb && cb()
      }

      // Update new position
      x2 = x1
      y2 = y1
      z2 = z1
    },
    [time],
  )

  useEffect(() => {
    // console.log('useDetectShake :: switch on');

    if (typeof window.DeviceMotionEvent != 'undefined') {
      start()
    } else {
      reset()
    }

    return () => {
      // console.log('useDetectShake :: switch off');

      reset()
    }
  }, [])
}

function requestDeviceOrientationPermission() {
  // iOS 14+
  if (
    typeof DeviceMotionEvent !== 'undefined' &&
    typeof DeviceMotionEvent.requestPermission === 'function'
  ) {
    DeviceMotionEvent.requestPermission().then(response => {
      if (response === 'granted') {
        console.log('accelerometer permission granted')
        window.addEventListener('deviceorientation', handleOrientation)
      }
    })
  } else if (
    typeof DeviceOrientationEvent !== 'undefined' &&
    typeof DeviceOrientationEvent.requestPermission === 'function'
  ) {
    // iOS 13+
    DeviceOrientationEvent.requestPermission()
      .then(response => {
        // console.log('Permission: ' + response)
        if (response === 'granted') {
          window.addEventListener('deviceorientation', handleOrientation)
        }
      })
      .catch(function(err) {
        console.error(err)
      })
  } else {
    // iOS <= 12
    // console.log('DeviceOrientationEvent is not defined')
    window.addEventListener('deviceorientation', handleOrientation)
  }
}

function handleOrientation(event) {
  // console.log("DeviceOrientationEvent handler", event);

  if (event.absolute) {
    return
  }

  z = event.alpha
  x = event.gamma // In degree in the range [-90,90]
  y = event.beta // In degree in the range [-180,180]

  // console.log("x: " + x.toFixed(3) + ", y: " + y.toFixed(3) + ", z: " + z.toFixed(3));
}

export function useDeviceOrientation(cb) {
  const { time, start, reset } = useTimer({
    interval: 10,
  })

  // Periodically check the position and fire
  // if the change is greater than the sensitivity
  useEffect(
    function() {
      cb && cb(x, y, z)
    },
    [time],
  )

  useEffect(() => {
    // console.log('useDeviceOrientation :: switch on')

    let btnPlay = document.getElementById('btnPlay')

    if (btnPlay) {
      document.getElementById('btnPlay').addEventListener(
        'click',
        function() {
          // console.log('useDeviceOrientation :: caught document click')

          requestDeviceOrientationPermission()
        },
        { once: true },
      )
    }

    if (typeof window.DeviceMotionEvent != 'undefined') {
      start()
    } else {
      reset()
    }

    return () => {
      // console.log('useDeviceOrientation :: switch off')

      reset()
    }
  }, [])
}

var DivElmnt, ScrollInterval, PreviousScrollTop

export function scrollDivInit(elID) {
  DivElmnt = document.getElementById(elID)

  DivElmnt.scrollTop = 0
  PreviousScrollTop = 0

  setTimeout(() => {
    ScrollInterval = setInterval(() => {
      scrollDiv()
    }, 10)
  }, 1000)

  DivElmnt.addEventListener('click', () => {
    pauseDiv()
  })
  DivElmnt.addEventListener('touchstart', () => {
    pauseDiv()
  })
  DivElmnt.addEventListener('touchend', () => {
    pauseDiv()
  })
  DivElmnt.addEventListener('touchmove', () => {
    pauseDiv()
  })
}

function scrollDiv() {
  if (!(DivElmnt.scrollTop >= DivElmnt.scrollHeight - DivElmnt.offsetHeight)) {
    DivElmnt.scrollTop = PreviousScrollTop
    PreviousScrollTop++
  } else {
    pauseDiv()
  }
}

function pauseDiv() {
  DivElmnt.style.overflowY = 'auto'
  clearInterval(ScrollInterval)
  DivElmnt.removeEventListener('click', () => {
    pauseDiv()
  })
  DivElmnt.removeEventListener('touchstart', () => {
    pauseDiv()
  })
  DivElmnt.removeEventListener('touchend', () => {
    pauseDiv()
  })
  DivElmnt.removeEventListener('touchmove', () => {
    pauseDiv()
  })
}
